var grid = document.querySelector('.masonry-grid');

if (grid) {
  var isotope = new Isotope(grid, {
    itemSelector: '.masonry-item',
    layoutMode: 'fitRows',
    masonry: {
      columnWidth: 0
    }
  });

  imagesLoaded(grid).on('progress', function () {
    isotope.layout();
  });

  window.addEventListener('resize', function () {
    isotope.layout();
  });

  grid.addEventListener('mouseover', function (event) {
    if (event.target.matches('.product-image, .product-details, .product-title')) {
      event.target.style.transform = 'scale(1.05)';
    }
  });

  grid.addEventListener('mouseout', function (event) {
    if (event.target.matches('.product-image, .product-details, .product-title')) {
      event.target.style.transform = 'scale(1)';
    }
  });
}
